import { useDashboard, useTeam } from '@vrplatform/data';
import { day } from '@vrplatform/utils';
import { Box, Text, Tooltip, rem } from '@mantine/core';
import { useNavbarExpanded } from '../../../hooks';
import { Icon } from '@vrplatform/icons';
import { useMemo } from 'react';
import { Link } from 'react-router';

export const NavbarBooksClosedDate = () => {
  const [{ booksClosedAt }] = useTeam();
  const { isDesktopExpanded } = useNavbarExpanded();
  const [dashboard] = useDashboard();

  const label = useMemo(
    () =>
      booksClosedAt && dashboard === 'propertyManager'
        ? `Books closed through ${day(booksClosedAt)
            .subtract(1, 'day')
            .format('ll')}`
        : undefined,
    [booksClosedAt, dashboard]
  );

  if (!label) return null;

  return (
    <Tooltip label={label} disabled={isDesktopExpanded}>
      <Box
        py={rem(8)}
        px={rem(8)}
        component={Link}
        to={`/settings/accounting/books-closed`}
        sx={(theme) => ({
          width: isDesktopExpanded ? '100%' : 'auto',
          marginInline: isDesktopExpanded ? undefined : 'auto',
          display: isDesktopExpanded ? 'flex' : 'block',
          flexWrap: 'nowrap',
          alignItems: 'center',
          gap: theme.spacing.xs,
          opacity: 0.5,
          borderRadius: theme.radius.md,
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          cursor: 'pointer',
          textDecoration: 'none',
          '&:hover': {
            backgroundColor: '#ffffff10',
            opacity: 1,
            color: '#ffffff!important',
            textDecoration: 'none',
          },
        })}
      >
        <Icon
          icon="Lock2Icon"
          color={(theme) => theme.colors.neutral[1]}
          size={isDesktopExpanded ? 17 : 19}
        />
        {isDesktopExpanded && (
          <Text size={rem(12)} c="neutral.1">
            {label}
          </Text>
        )}
      </Box>
    </Tooltip>
  );
};
